const RegistroPresencaActionTypes = {
    PRESENCA: "registro/presenca",
}

export default RegistroPresencaActionTypes;